var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"title"},[_vm._v("关联原订单：")]),_vm._v(" "),_c('form-text-box',{ref:"searchForm",staticClass:"original-order",attrs:{"column":3,"dataList":_vm.orderSearchConfig.list,"model":_vm.orderSearchConfig.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }